var _path, _path2, _path3, _path4, _circle, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3193 3.41016C19.0075 3.41016 20.3522 3.41048 21.3789 3.93359C22.2819 4.39375 23.0164 5.12825 23.4766 6.03125C23.9995 7.05792 24 8.40217 24 11.0898V13.2138C24 13.752 23.2417 14.0464 22.7888 13.7555C22.6153 13.644 22.5 13.4557 22.5 13.2494V11.0898C22.5 9.72122 22.4987 8.78464 22.4395 8.05957C22.3816 7.35209 22.2755 6.97856 22.1396 6.71191C21.8233 6.09122 21.3189 5.58586 20.6982 5.26953C20.4316 5.13371 20.0578 5.02852 19.3506 4.9707C18.6254 4.91146 17.6882 4.91016 16.3193 4.91016H7.67969C6.31094 4.91016 5.37453 4.91146 4.64941 4.9707C3.94198 5.02851 3.56842 5.1337 3.30176 5.26953C2.6809 5.58587 2.17576 6.09108 1.85938 6.71191C1.72354 6.97855 1.61836 7.3522 1.56055 8.05957C1.50131 8.78464 1.5 9.72122 1.5 11.0898V17.3184C1.5 18.6868 1.50135 19.6236 1.56055 20.3486C1.61832 21.0557 1.72366 21.4297 1.85938 21.6963C2.17572 22.3171 2.68092 22.8223 3.30176 23.1387C3.56843 23.2745 3.94179 23.3807 4.64941 23.4385C5.37453 23.4977 6.31094 23.498 7.67969 23.498H12.2503C12.4566 23.498 12.6449 23.6134 12.7564 23.787C13.0472 24.2399 12.7527 24.998 12.2145 24.998H7.67969C5.15966 24.998 3.82089 24.9984 2.81738 24.5674L2.62109 24.4756C1.83075 24.0729 1.16918 23.46 0.708008 22.708L0.523438 22.3779C0.000376465 21.3512 0 20.0064 0 17.3184V11.0898C-1.8607e-08 8.57012 -0.000284628 7.23099 0.430664 6.22754L0.523438 6.03125C0.926104 5.24106 1.5382 4.57931 2.29004 4.11816L2.62109 3.93359C3.6478 3.41056 4.99179 3.41016 7.67969 3.41016H16.3193Z",
    fill: "#6C6859"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44165 1.60156V3.92967",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5581 1.60156V3.92967",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 9.46875H23",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 19,
    r: 5.25,
    stroke: "#6C6859",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16V19.25L20.5 20.5",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/CalendarIcon.37e14d4e8845f96bcdf16aaed30e6a1e.svg";
export { ForwardRef as ReactComponent };